import React, { useEffect, useState } from 'react';
import {
    Box, Typography, Card, CardContent, Stack,
    IconButton, Tooltip, CircularProgress
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import axios from 'axios';
import { toast } from 'react-toastify';

const WEBHOOK_TYPES = ['chartink', 'sequence'];

const WebhookURLs = () => {
    const [webhookUrls, setWebhookUrls] = useState({});
    const [loading, setLoading] = useState(true);
    const [copyState, setCopyState] = useState({});
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


    const fetchWebhookUrls = async () => {
        setLoading(true);
        try {
            const urls = {};
            const token = localStorage.getItem("token");
            for (const type of WEBHOOK_TYPES) {
                const res = await axios.get(`${API_BASE_URL}/webhook/url/${type}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                urls[type] = res.data.webhook_url;
            }
            setWebhookUrls(urls);
        } catch (err) {
            toast.error('Failed to fetch webhook URLs');
        } finally {
            setLoading(false);
        }
    };

    const handleCopy = (type) => {
        navigator.clipboard.writeText(webhookUrls[type])
            .then(() => {
                toast.success(`${type} webhook URL copied!`);
                setCopyState((prev) => ({ ...prev, [type]: true }));
                setTimeout(() => setCopyState((prev) => ({ ...prev, [type]: false })), 1200);
            })
            .catch(() => toast.error('Copy failed'));
    };

    useEffect(() => {
        fetchWebhookUrls();
    }, []);

    if (loading) return <CircularProgress />;

    return (
        <Box mt={4}>
            <Typography variant="h6" gutterBottom>
                Webhook URLs
            </Typography>

            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                <WarningAmberIcon color="warning" />
                <Typography color="text.secondary">
                    Never share these webhook URLs publicly
                </Typography>
            </Stack>

            <Stack spacing={2}>
                {WEBHOOK_TYPES.map((type) => (
                    <Card key={type} variant="outlined" sx={{ bgcolor: "#fdfdfd" }}>
                        <CardContent>
                            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', textTransform: 'capitalize' }}>
                                {type} Webhook URL
                            </Typography>
                            <Box
                                display="flex"
                                alignItems="center"
                                sx={{
                                    backgroundColor: "#f5f5f5",
                                    borderRadius: 1,
                                    px: 2,
                                    py: 1,
                                    overflowX: 'auto',
                                    fontFamily: 'monospace',
                                    fontSize: '0.875rem',
                                }}
                            >
                                <Box flexGrow={1}>{webhookUrls[type]}</Box>
                                <Tooltip title="Copy to clipboard">
                                    <IconButton
                                        color={copyState[type] ? "success" : "primary"}
                                        onClick={() => handleCopy(type)}
                                        sx={{
                                            width: '20px',
                                            height: '20px',
                                            minWidth: '20px',
                                            minHeight: '20px',
                                            ml: 1, // optional: adds a little spacing from the text
                                            p: '2px', // tight padding
                                        }}
                                    >
                                        <ContentCopyIcon sx={{ fontSize: '16px' }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </CardContent>
                    </Card>
                ))}
            </Stack>
        </Box>
    );
};

export default WebhookURLs;
